import script from "./SoftwareForm.vue?vue&type=script&setup=true&lang=js"
export * from "./SoftwareForm.vue?vue&type=script&setup=true&lang=js"

import "./SoftwareForm.vue?vue&type=style&index=0&id=19e0c8d6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19e0c8d6"]])

export default __exports__